<script lang="ts">
  import { go } from "../../lib/router.svelte";
</script>

<section class="max-w-md mx-auto px-6 py-24 text-center">
  <h1 class="text-3xl font-bold">Checkout cancelled</h1>
  <p class="mt-4 text-slate-400">No charge was made.</p>
  <a
    href="/"
    onclick={(e) => go(e, "/")}
    class="mt-8 inline-block px-5 py-3 rounded-md border border-white/15 hover:border-white/30"
  >
    Back to home
  </a>
</section>
